module.exports = __webpack_public_path__ + "static/media/sticky-boot.f097559f.svg";